import React from 'react';

const SiteIdling = (props) => {
  return <div>Your session will expire in {props.minutes} minutes due to inactivity</div>;
};

export default SiteIdling;
